export const ALL = 'all';
export const INVITES = 'invites';
